import type { MenuItem, VoyageStatistic, ProductItem } from '~/types'

export const productItems: ProductItem[] = [
  {
    title: 'Watchkeeper',
    description: 'Market leading predictive analytics and data capture',
    backgroundColor: 'bg-cetoLime1',
    borderColor: 'border-cetoBlue1',

    iconName: 'watchkeeper',
    routeName: 'watchkeeper',
    iconColor: 'stroke-slate-900',
    content: 'Our high fidelity predictive analytics solution, transmitting live data from ship to shore.',
    properties: [
      { content: 'Prevent Machinery Breakdowns', icon: 'tick' },
      { content: 'Condition & Performance Insights', icon: 'tick' },
      { content: 'High Frequency Data Capture', icon: 'tick' }
    ]
  },
  {
    title: 'CarbonID',
    description: 'Emissions monitoring, reporting & compliance',
    backgroundColor: 'bg-cetoBlue1',
    borderColor: 'border-cetoLime1',
    iconName: 'carbonid',
    routeName: 'carbonid',
    iconColor: 'stroke-slate-200',
    content: 'Our ever-evolving carbon emissions monitoring tool, keeping you on the right side of compliance.',
    properties: [
      { content: 'EU MRV Compliance', icon: 'tick' },
      { content: 'IMO DCS Compliance', icon: 'tick' },
      { content: 'CII Monitoring & Forecasting', icon: 'tick' }
    ]
  },
  {
    title: 'Connected Insurance',
    description: 'Connected insurance that works for you',
    backgroundColor: 'bg-cetoBlue400',
    borderColor: 'border-wave-crest-50',
    iconName: 'insurance',
    routeName: 'insurance',
    iconColor: 'stroke-slate-900',
    content: 'Our market-beating insurance, built on realtime data and AI insights.',
    properties: [
      { content: 'Competitively Priced Insurance', icon: 'tick' },
      { content: 'Insights to Improve Safety', icon: 'tick' },
      { content: 'Compatible With All Data Logging Solutions', icon: 'tick' }
    ]
  }
]

// To be added back in when solutions are developed out further.
// export const solutionItems: ProductItem[] = [
//   {
//     title: 'Brokers',
//     description: 'Data-driven tools for tailored insurance policies and risk management',
//     backgroundColor: 'bg-cetoBlue1',
//     borderColor: 'border-wave-crest-50',
//     iconName: 'carbonid',
//     routeName: 'for-brokers',
//     iconColor: 'stroke-slate-200',
//     content: 'Our ever-evolving carbon emissions monitoring tool, keeping you on the right side of compliance.',
//     properties: [
//       { content: 'EU MRV Compliance', icon: 'tick' },
//       { content: 'IMO DCS Compliance', icon: 'tick' },
//       { content: 'CII Monitoring & Forecasting', icon: 'tick' }
//     ]
//   },
//   {
//     title: 'Fleet Managers',
//     description: 'Insights to optimise vessel performance and enhance daily operations',
//     backgroundColor: 'bg-cetoBlue1',
//     borderColor: 'border-wave-crest-50',
//     iconName: 'carbonid',
//     routeName: 'for-fleet-managers',
//     iconColor: 'stroke-slate-200',
//     content: 'Our ever-evolving carbon emissions monitoring tool, keeping you on the right side of compliance.',
//     properties: [
//       { content: 'EU MRV Compliance', icon: 'tick' },
//       { content: 'IMO DCS Compliance', icon: 'tick' },
//       { content: 'CII Monitoring & Forecasting', icon: 'tick' }
//     ]
//   },
//   {
//     title: 'Ship Owners',
//     description: 'Insights to optimise vessel performance and enhance daily operations',
//     backgroundColor: 'bg-cetoBlue1',
//     borderColor: 'border-wave-crest-50',
//     iconName: 'carbonid',
//     routeName: 'for-ship-owners',
//     iconColor: 'stroke-slate-200',
//     content: 'Our ever-evolving carbon emissions monitoring tool, keeping you on the right side of compliance.',
//     properties: [
//       { content: 'EU MRV Compliance', icon: 'tick' },
//       { content: 'IMO DCS Compliance', icon: 'tick' },
//       { content: 'CII Monitoring & Forecasting', icon: 'tick' }
//     ]
//   },
//   {
//     title: 'Seafarers',
//     description: 'Insights to optimise vessel performance and enhance daily operations',
//     backgroundColor: 'bg-cetoBlue1',
//     borderColor: 'border-wave-crest-50',
//     iconName: 'carbonid',
//     routeName: 'for-seafarers',
//     iconColor: 'stroke-slate-200',
//     content: 'Our ever-evolving carbon emissions monitoring tool, keeping you on the right side of compliance.',
//     properties: [
//       { content: 'EU MRV Compliance', icon: 'tick' },
//       { content: 'IMO DCS Compliance', icon: 'tick' },
//       { content: 'CII Monitoring & Forecasting', icon: 'tick' }
//     ]
//   }
// ]

export const menuItems: MenuItem[] = [
  {
    name: 'products',
    display: 'Products',
    subItems: productItems
  },
  // To be added back in when solutions are developed out further.
  // {
  //   name: 'solutions',
  //   display: 'Solutions',
  //   subItems: solutionItems
  // },
  { name: 'news', display: 'News' },
  { name: 'about', display: 'About' },
  { name: 'contact', display: 'Contact' },
  { name: 'careers', display: 'We are hiring' }
]

export const mobileMenuItems: MenuItem[] = [
  { name: 'carbonid', display: 'CarbonID' },
  { name: 'watchkeeper', display: 'Watchkeeper' },
  { name: 'insurance', display: 'Insurance' },
  { name: 'news', display: 'News' },
  { name: 'about', display: 'About' },
  { name: 'careers', display: 'We are hiring' },
  { name: 'contact', display: 'Contact' },
  { name: 'login', display: 'Sign in' }
]

export const socialLinks = [
  { name: 'x-twitter', url: 'https://twitter.com/cetoai', logoColor: '#FFFFFF' },
  { name: 'linkedin', url: 'https://www.linkedin.com/company/37552076', logoColor: '#027FBC' }
]

/**
 * Function generates tab bar navigation items for when a vessel is selected
 * @param vesselId stringified _id of vessel provided in url stream
 * @param routeDestination the final location of the url
 * @returns array of routes for use in tab bar
 */
export const vesselNavItems = (vesselId: string, routeDestination: string) => [
  {
    name: 'Overview',
    active: routeDestination === vesselId,
    navLink: `/dashboard/vessel/${vesselId}/`
  },
  {
    name: 'Performance',
    active: routeDestination === 'performance',
    navLink: `/dashboard/vessel/${vesselId}/performance`
  },
  {
    name: 'Navigation',
    active: routeDestination === 'navigation',
    navLink: `/dashboard/vessel/${vesselId}/navigation`
  },
  {
    name: 'Engine',
    active: routeDestination === 'engine',
    navLink: `/dashboard/vessel/${vesselId}/engine`
  },
  {
    name: 'Auxilliary Equipment',
    active: routeDestination === 'aux',
    navLink: `/dashboard/vessel/${vesselId}/aux`
  },
  {
    name: 'Other Equipment',
    active: routeDestination === 'equipment',
    navLink: `/dashboard/vessel/${vesselId}/equipment`
  }
]

/**
 * Function generates tab bar navigation items for when fleet view is selected
 * @param routeDestination the final location of the url
 * @returns array of routes for use in tab bar
 */
export const fleetNavItems = (routeDestination: string) => [
  {
    name: 'Overview',
    active: routeDestination === 'dashboard',
    navLink: '/dashboard'
  },
  {
    name: 'Notifications',
    active: routeDestination === 'notifications',
    navLink: '/dashboard/notifications'
  },
  {
    name: 'Vessels',
    active: routeDestination === 'compare',
    navLink: '/dashboard/compare' // Update URL for new page
  },
  {
    name: 'CII Forecast',
    active: routeDestination === 'forecast',
    navLink: '/dashboard/forecast'
  },
  {
    name: 'MPI Rating',
    active: routeDestination === 'mpi',
    navLink: '/dashboard/compare'
  }
]

export const voyageStatisticalData: VoyageStatistic[] = [
  {
    name: 'Journey Time',
    key: 'timeElapsed',
    units: 'hours'
  },
  {
    name: 'Distance Travelled',
    key: 'distanceTravelled',
    units: 'nautical miles'
  },
  {
    name: 'Fuel Consumption',
    key: 'fuelUsed',
    units: 'litres'
  },
  {
    name: 'Carbon Emissions',
    key: 'carbonEmitted',
    units: 'kg'
  },
  {
    name: 'Average Engine Speed',
    key: 'averageRPM',
    units: 'rpm'
  },
  {
    name: 'Average Speed',
    key: 'averageSpeed',
    units: 'knots'
  }
]

export const subHeaderTabbedRoutes = ['dashboard-vessels-', 'dashboard-vessels-vesselId-voyages-']
